export default __webpack_public_path__ + "1.18.12/static/media/LibreDataShare_Hebrew.9abfb84b.svg";